import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderLinkComponent } from './header-link/header-link.component';

@Component({
  selector: 'app-portal-administration-link',
  standalone: true,
  imports: [CommonModule, TranslateModule, HeaderLinkComponent],
  template: `
    <app-header-link caption="{{ 'admin.title' | translate }}" icon="settings_icon" link="/admin" />
  `,
})
export class PortalAdministrationLinkComponent {
  @Input() isSmall: boolean;
}
